import { z } from '@qred/components-library';
import {
  validateEmail,
  validatePersonalNumber,
  validatePhoneNumber,
} from '@qred/shared-component-library/src/validators';
import { NLAddressLookupSchema } from '~/components/shared/NLAddressLookup/NLAddressLookup';
import {
  marketHasAddress,
  marketHasDateOfBirth,
  marketHasPersonalNumber,
  marketShouldAskLoanApplicantForFirstAndLastName,
} from '~/constants/markets';
import { CountryCode } from '~/enums';
import { requiredString } from '~/helpers/schema.helper';

export const DEAddressSchema = z.object(
  {
    city: requiredString(),
    street: requiredString(),
    zipCode: requiredString(),
  },
  { required_error: 'ValidationErrors.Required' }
);

const createAddressSchema = (market: CountryCode) => {
  switch (market) {
    case CountryCode.DE:
      return DEAddressSchema;

    case CountryCode.NL:
      return NLAddressLookupSchema.shape.address;
    default:
      return z.undefined();
  }
};

export const firstAndLastNameSchema = z.object({
  firstName: requiredString(),
  lastName: requiredString(),
});

export const dateOfBirthSchema = z.date({
  required_error: 'ValidationErrors.Required',
});

export const createPersonalNumberSchema = (market: CountryCode) =>
  requiredString({
    validator: (value) => validatePersonalNumber(value, market),
    message: 'ValidationErrors.PersonalNumber',
  });

export const createPersonalInformationSchema = (market: CountryCode) => {
  return z.object({
    phone: requiredString({
      validator: (value) => validatePhoneNumber(value, market),
      message: 'ValidationErrors.Phone',
    }),
    email: requiredString({
      validator: (value) => validateEmail(value),
      message: 'ValidationErrors.Email',
    }),
    ...(marketShouldAskLoanApplicantForFirstAndLastName[market]
      ? firstAndLastNameSchema.shape
      : {
          firstName: z.undefined(),
          lastName: z.undefined(),
        }),
    personalNumber: marketHasPersonalNumber[market]
      ? createPersonalNumberSchema(market)
      : z.undefined(),
    dateOfBirth: marketHasDateOfBirth[market]
      ? dateOfBirthSchema
      : z.undefined(),
    address: marketHasAddress[market]
      ? createAddressSchema(market)
      : z.undefined(),
  });
};

export type PersonalInformationForm = z.infer<
  ReturnType<typeof createPersonalInformationSchema>
>;
